module.exports = __webpack_public_path__ + "img/fig13.b8b3bd4e.jpg";